// filter-clear.ts — shared "Clear all filters" wiring for the catalog filter panel footer
// (ft_filter_panel_footer() in includes/functions.php). Every renderer that owns a filter panel
// (table / cards / games / adventures) calls wireFilterClearButton() right after it wires the Apply
// button, so the footer's Clear-all behaves identically everywhere: reset every control inside the
// panel to empty, then re-run that renderer's own filter (the panel STAYS OPEN — unlike Apply, which
// closes it). Tom Select <select>s reset via their instance; plain inputs/checkboxes reset directly.
//
// Pages whose filter is a chip set (library / my-sources) are NOT covered here — chips aren't form
// controls; they'd need their own active-state reset.
import type { CatalogListConfig } from './types';

export function wireFilterClearButton(config: CatalogListConfig, apply: () => void): void {
    if (!config.filterClearButtonId || !config.filterPanelId) return;
    const clearBtn = document.getElementById(config.filterClearButtonId);
    const panel = document.getElementById(config.filterPanelId);
    if (!clearBtn || !panel) return;
    clearBtn.addEventListener('click', () => {
        panel.querySelectorAll<HTMLElement>('select, input').forEach((el) => {
            const ts = (el as { tomselect?: { clear: (silent?: boolean) => void } }).tomselect;
            if (ts && typeof ts.clear === 'function') {
                ts.clear(true); // silent — single apply() below
            } else if (el instanceof HTMLInputElement) {
                if (el.type === 'checkbox' || el.type === 'radio') el.checked = false;
                else el.value = '';
            } else if (el instanceof HTMLSelectElement) {
                el.selectedIndex = -1;
                el.value = '';
            }
        });
        apply();
    });
}
